// extracted by mini-css-extract-plugin
export default {"page-shop":"map_page-shop__NTZm3","title":"map_title__COTDk"};